module.exports = __webpack_public_path__ + "img/0Q3B8360-70_H_WoodMatted_MockedUp.288792b3.jpg";